import { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

export function SidebarProvider({ children }) {
  const [isCompact, setIsCompact] = useState(false);

  // Récupérer l'état du localStorage au montage
  useEffect(() => {
    const saved = localStorage.getItem('sidebarCompact');
    if (saved !== null) {
      setIsCompact(JSON.parse(saved));
    }
  }, []);

  // Sauvegarder l'état dans le localStorage
  const toggleCompact = () => {
    setIsCompact((prev) => {
      const newState = !prev;
      localStorage.setItem('sidebarCompact', JSON.stringify(newState));
      return newState;
    });
  };

  return (
    <SidebarContext.Provider value={{ isCompact, toggleCompact }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebarContext() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebarContext must be used within SidebarProvider');
  }
  return context;
}
